import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class NumberFormatService {
  public static locale = (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.language;

  public static currency(value: number, currencyCode: string, showCode: boolean = false): string {
    const options: Record<string, any> = {
      style: 'currency',
      currency: currencyCode,
    }
    if (showCode) {
      options.currencyDisplay = "code"
    }

    const CurrencyFormat = new Intl.NumberFormat(NumberFormatService.locale, options);
    return CurrencyFormat.format(value);
  }
}
